import axiosInstances from '@/helper/axiosInstances';

const baseURL = import.meta.env.VITE_API_URL;

export default function file() {
	// Get fresh instances for each request
	const getInstance = () => {
		const { axiosInstance, axiosInstanceF } = axiosInstances();
		return { axiosInstance, axiosInstanceF };
	};

	async function getDownloadLog(params) {
		const { axiosInstance } = getInstance();
		const method = 'get';
		const url = `${baseURL}downloadlog/`;
		const response = await axiosInstance.request({
			method,
			url,
			params,
		});
		return response;
	}

	async function getAttachments(id) {
		const { axiosInstance } = getInstance();
		const method = 'get';
		const url = `${baseURL}list_attachment/${id}/`;
		const response = await axiosInstance.request({
			method,
			url,
		});
		return response;
	}

	async function getPublicAttachments(id, params) {
		const { axiosInstance } = getInstance();
		const method = 'get';
		const url = `${baseURL}list_attachment/${id}/`;
		const response = await axiosInstance.request({
			method,
			url,
			params,
			headers: {
				'Content-Type': 'application/json',
			},
		});
		return response;
	}

	async function getComponentAttachments(id) {
		const { axiosInstance } = getInstance();
		const method = 'get';
		const url = `${baseURL}component_attachment/${id}/`;
		const response = await axiosInstance.request({
			method,
			url,
		});
		return response;
	}

	async function checkBlobFile(data) {
		const { axiosInstanceF } = getInstance();
		const method = 'post';
		const url = `${baseURL}check_file/`;
		const response = await axiosInstanceF.request({
			method,
			url,
			data,
		});
		return response;
	}

	return { getDownloadLog, getAttachments, getPublicAttachments, getComponentAttachments, checkBlobFile };
}
